import SelectMedia from "./SelectMedia";

export default SelectMedia;
